import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from '../vista-usuario/vista-usuario.state';

import {
  selectAuthPersona,
  selectPersonaUserIsLoading
} from '../persona/entity-personas/entity-personas.selectors';
import { selectUsuario } from '../persona/entity-usuarios/entity-usuarios.selectors';

@Injectable({ providedIn: 'root' })
export class PersonaGuardService implements CanActivate {
  constructor(private router: Router, private store: Store<State>) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const c1 = combineLatest([
      this.store.select(selectPersonaUserIsLoading),
      this.store.select(selectUsuario),
      this.store.select(selectAuthPersona)
    ])
      .pipe(
        map(([isLoading, authUser, authPersona]) => {
          if (authPersona) {
            return true;
          } else {
            this.router.navigate(['/registro'], {
              queryParams: { returnUrl: state.url }
            });
            return false;
          }
        })
      );
    return c1;
  }
}
